import React from "react";
import SectionText from "./SectionText";
import Scroller from "./Scroller";

function Hero(props) {
	let container = "container";
	if (props.fluid) {
		container = "container-fluid"
	}
	let classes = `${container} ${props.className}`;
	return (
		<div id="hero">
			<div className={ classes }>
				{ props.children }
				<Scroller to={ props.link } />
			</div>
		</div>
	)
}

export default Hero;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Hero.jsx
 **/